import { theme } from '@styles';

export const getModalContainerProps = ({ isTabletSM }) => ({
  backgroundColor: theme.colors.white[10],
  border: `1px solid ${theme.colors.white[10]}`,
  borderRadius: '0px',
  maxHeight: isTabletSM ? '100%' : '480px',
  maxWidth: '640px',
  style: isTabletSM
    ? {
        margin: 'auto',
      }
    : {},
  width: '100%',
});

export const calculateProgressBarWidth = ({ rankCheckPoint, rankPoints }) =>
  `${(100 * rankPoints) / rankCheckPoint}%`;
